<template>
  <detail-layout ref="layout" :tableCfg="tableCfg">
    <template slot="FormLayout" scope="props">
      <b-form ref="form" class="col-md-6 offset-md-2" autocomplete="off">
        <div v-if="dataValid" >
          <detail-field label="Code" field="cntry_code" :rec="props.rec" :isReadOnly="isReadOnly" vvalidate="required" :validator="validator"/>
          <detail-field label="Name" field="cntry_name" :rec="props.rec" :isReadOnly="isReadOnly" vvalidate="required" :validator="validator"/>
        </div>
      </b-form>
    </template>
  </detail-layout>
</template>

<script>
import DetailMixin from '../../components/DetailMixin'
import FieldDefs from './FieldDefs.js'

export default {
  name: 'country_detail',
  mixins: [DetailMixin],
  data () {
    return {
      tableCfg: FieldDefs
    }
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// Detail.vue?13af1b8b